import styles from "./FeedTemplateIcon.module.css";
import React from "react";
import PropTypes from "prop-types";
import StandardContentIcon from "../../assests/Standard_Content.svg";
// import StandingOrderIcon from "../../assests/Digital_Delivery.svg";
import StandingOrderIcon from "../../assests/standing-order-icon.svg";

import BannerIcon from "../../assests/Banner_Icon.svg";

/**
 * View. An icon that displays the type of feed template.
 */

export function FeedTemplateIcon({ feedTemplateType, iconSize }) {
  const iconSrc =
    feedTemplateType === "Standard Content"
      ? StandardContentIcon
      : feedTemplateType === "Standing Order"
      ? StandingOrderIcon
      : BannerIcon;

  return (
    <>
      <img
        alt="FeedTemplate Icon"
        className={styles.feedIcon}
        src={iconSrc}
        style={{ height: iconSize, width: iconSize }}
      />
    </>
  );
}

FeedTemplateIcon.propTypes = {
  /**
   * String that states the type of feed template.
   */
  feedTemplateType: PropTypes.oneOf([
    "Standard Content",
    "Standing Order",
    "Banner",
  ]),

  iconSize: PropTypes.string,
};
